import { getWindow } from '@/shared/lib/getWindow';
import { getRequestContext } from '@/shared/lib/requestContext';

export const trackGoal = (goal: string, params?: object) => {
    const { yaCounter } = getRequestContext();

    getWindow()?.ym(yaCounter, 'reachGoal', goal, params);
};
